<div class="card">
  <div class="card-body">
    @if (canNavigateToJobs) {
      <a [routerLink]="'/jobs'" class="card-title h5">
        <span class="material-symbols-outlined">speed</span>
        <span style="vertical-align: middle" class="ms-2">{{ configuration.title || ('dashboard.averagePickTime.title' | translate) }}</span>
        <span class="badge rounded-pill text-bg-warning ms-2 beta-badge">
          {{ 'dashboard.badges.beta' | translate }}
        </span>
      </a>
    } @else {
      <div class="card-title h5">
        <span class="material-symbols-outlined">speed</span>
        <span style="vertical-align: middle" class="ms-2">{{ configuration.title || ('dashboard.averagePickTime.title' | translate) }}</span>
        <span class="badge rounded-pill text-bg-warning ms-2 beta-badge">
          {{ 'dashboard.badges.beta' | translate }}
        </span>
      </div>
    }
    @if (configuration.description) {
      <h6 class="card-subtitle mb-2 mt-2 text-muted">{{ configuration.description }}</h6>
    }

    <app-loading-indicator [loading]="isLoading"></app-loading-indicator>

    @if (!isLoading) {
      <div class="average-pick-time-widget">
        <div class="d-flex justify-content-end align-items-center mb-3">
          <div class="date-range text-muted small">
            <span class="material-symbols-outlined" style="font-size: 16px; vertical-align: middle;">calendar_today</span>
            @if (isCustomRange()) {
              <span class="ms-1">{{ getDateRangeDisplay() }}</span>
            } @else {
              <span class="ms-1">{{ 'dashboard.edit.JobDashboardComponent.rangeOptions.' + getRangeKey() | translate }}</span>
            }
          </div>
        </div>

        @if (error) {
          <div class="alert alert-danger py-2 mb-3">
            <span class="material-symbols-outlined me-2" style="font-size: 18px; vertical-align: middle;">error</span>
            {{ error }}
          </div>
        }

        @if (warnings.length > 0) {
          <div class="warnings mb-3">
            @for (warning of warnings; track warning) {
              <div class="alert alert-warning py-1 mb-1">{{ warning }}</div>
            }
          </div>
        }

        @if (!isConfigured()) {
          <div class="no-data">
            {{ 'dashboard.averagePickTime.noFieldConfigured' | translate }}
          </div>
        } @else if (!hasData()) {
          @if (!error && warnings.length === 0) {
            <div class="no-data">
              {{ 'dashboard.averagePickTime.noData' | translate }}
            </div>
          }
        } @else {
          <div class="kpi-display text-center">
            <div class="kpi-value">{{ formatAverage() }}</div>
            <div class="kpi-label text-muted">{{ 'dashboard.averagePickTime.perPick' | translate }}</div>
          </div>
          <div class="kpi-context d-flex justify-content-center text-muted small mt-3">
            <span>
              {{ 'dashboard.averagePickTime.totalDuration' | translate }}:
              <strong>{{ formatNumber(result!.totalDurationSeconds) }} s</strong>
            </span>
            <span class="mx-2">·</span>
            <span>
              {{ 'dashboard.averagePickTime.totalUnits' | translate }}:
              <strong>{{ formatNumber(result!.totalUnits) }}</strong>
            </span>
            <span class="mx-2">·</span>
            <span>
              {{ 'dashboard.averagePickTime.jobs' | translate }}:
              <strong>{{ result!.jobCount }}</strong>
            </span>
          </div>
        }
      </div>
    }
  </div>
</div>
